import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IFailedPayload } from 'redux/types/Allocation.types';
import {
  IAssignChannelRequest,
  IAssignChannelResponse,
} from 'redux/types/Channel.types';

export interface ChannelAllocationInitialState {
  loading: boolean;
  error: IFailedPayload | null;
  message: string;
  orchestrator: any;
}

export const channelAllocationInitialState: ChannelAllocationInitialState = {
  loading: false,
  error: null,
  message: '',
  orchestrator: null,
};
const channelAllocationSlice = createSlice({
  name: 'channelAllocation',
  initialState: channelAllocationInitialState,
  reducers: {
    assignChannel: (state, action: PayloadAction<IAssignChannelRequest>) => {
      state.loading = true;
      state.error = null;
    },
    assignChannelSuccess: (
      state,
      action: PayloadAction<IAssignChannelResponse>
    ) => {
      state.loading = false;
      state.message = action.payload.message;
    },
    assignChannelFailure: (state, action: PayloadAction<IFailedPayload>) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetChannelAllocationMessage: (state) => {
      state.message = '';
    },
  },
});

export const {
  assignChannel,
  assignChannelSuccess,
  assignChannelFailure,
  resetChannelAllocationMessage,
} = channelAllocationSlice.actions;

export default channelAllocationSlice.reducer;
